import React from "react";
import DatasourceSettings from "../../settings_sidebar/datasource/DatasourceSettings";
import DataStripDatasetWidgetSettingsRow from "./DataStripDatasetWidgetSettingsRow";
import CollapsibleSection from "../../../common/CollapsibleSection.jsx";
import FormulaFieldsSettings from "../../settings_sidebar/ag_chart/formula/FormulaFieldsSettings.jsx";

function DataStripDatasetWidgetSettings({ widgetId }){
    return (
        <>
            <DatasourceSettings
                widgetId={widgetId}
                datasource_props={{
                   DatasourceSettingsRowComponent: DataStripDatasetWidgetSettingsRow
                }}
                chart_settings_props={{
                    additional_settings: [
                        'number_format', 
                        'stacking_direction',
                        'image_fontSize',
                        'value_fontSize',
                        'unit_fontSize',
                        'name_item_fontSize'
                    ],
                }}
            />
            <hr />
            <CollapsibleSection title={I18n.t('formula_fields')} initialCollapsed={true}>
                <FormulaFieldsSettings widgetId={widgetId} />
            </CollapsibleSection>
        </>
    )
}

export default DataStripDatasetWidgetSettings;
